module.exports = __webpack_public_path__ + "img/fn-goal-3.83227b1f.jpg";